"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formula_form_1 = __importDefault(require("./formula.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
// import DxFilterBuilder from 'devextreme/ui/filter_builder';
//import dxTagBox from 'devextreme/ui/tag_box';
// import component from '../../templates/bootstrap/component';
// import { debug } from 'webpack';
// import AriForm from '../../../AriForm';
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class FormulaComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.checks = [];
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'formula',
            label: 'Formula',
            dataSrc: 'aripost',
            dataSourcePath: 'dataSource',
            defaultRulePath: 'rule',
            // data: {
            //   custom: [{ dataSource: '', defaultRule: '' }],
            //   json: '',
            //   url: '',
            //   resource: '',
            //   custom: ''
            // },
            displayInfo: true,
            defaultRule: '',
            formulaDataSource: '',
            align: 'justify-content-start',
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return FormulaComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    render() {
        var view = `<div style="padding: 10px; background-color: transparent;" ref="${this.component.key}-builderFormula"></div>`;
        return super.render(view);
    }
    bindData(dataSource, rule) {
        var items = Array.prototype.slice.call(this.refs[`${this.component.key}-builderFormula`], 0);
        //this.component.formulaDataSource = dataSource;
        this.formulaDataSource = dataSource;
        var formulaDataSource = dataSource === '' ? [{ 'dataField': 'Test', 'dataType': 'number' }] : JSON.parse(dataSource);
        var defaultRule = rule === '' ? [] : JSON.parse(rule);
        items.forEach(item => {
            this.attachBuilder(item, formulaDataSource, defaultRule);
        });
        this.setValue(defaultRule);
    }
    setValue(value, flags = {}) {
        super.setValue(value, flags);
    }
    setRule(rule) {
        var formulaDataSource = JSON.parse(this.formulaDataSource);
        var defaultRule = rule;
        try {
            defaultRule = rule === '' ? [] : JSON.parse(rule);
        }
        catch (_a) {
            //do nothing
        }
        var items = Array.prototype.slice.call(this.refs[`${this.component.key}-builderFormula`], 0);
        items.forEach(item => {
            this.attachBuilder(item, formulaDataSource, defaultRule);
        });
        this.setValue(defaultRule);
    }
    getValue() {
        return this.value;
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        refs[`${this.component.key}-builderFormula`] = 'multiple';
        refs[`${this.component.key}-btn`] = 'multiple';
        this.loadRefs(element, refs);
        switch (this.component.dataSrc) {
            case 'custom':
                this.bindData(this.component.formulaDataSource, this.component.defaultRule);
                break;
            case 'aripost': {
                var args = this.evalContext(args);
                args.form = this.root;
                this.emit('requestAri', {
                    com: this.component,
                    url: this.interpolate(this.component.ariaction),
                    aribody: this.component.aribody,
                    resultType: null,
                    script: (result) => {
                        this.bindData(this.component.dataSourcePath ? JSON.stringify(result[this.component.dataSourcePath]) : JSON.stringify(result), this.component.defaultRulePath ? JSON.stringify(result[this.component.defaultRulePath]) : '');
                    },
                    args: args
                });
                break;
            }
        }
        // Allow basic component functionality to attach like field logic and tooltips.
        return super.attach(element);
    }
    updateValue(value, flags) {
        const changed = super.updateValue(value, flags);
        this.previousValue = this.dataValue;
        return changed;
    }
}
FormulaComponent.editForm = formula_form_1.default;
FormulaComponent.builderInfo = {
    title: 'Formula',
    group: 'advanced',
    icon: 'wrench',
    weight: 70,
    documentation: 'http://help.ari.form/userguide/',
    schema: FormulaComponent.schema()
};
exports.default = FormulaComponent;
